/**
 * Панель Our latest works в конце скролла ПК.
 * Не править path без нужды — только обёртка слайда.
 */

import { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import useLatestWorksBtnFade from "../../hooks/useLatestWorksBtnFade";

const PcLatestWorks = forwardRef(function PcLatestWorks({ onSendEmail }, ref) {
    const navigate = useNavigate();
    useLatestWorksBtnFade(ref);

    return (
<div ref={ref} className="group-73-container latest-works-block pc-scroll-slide" style={{ position: 'absolute', top: 0, left: '50%', minWidth: '1000px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '2rem', fontWeight: 700, color: '#000', marginBottom: '2rem', textAlign: 'center' }}>
        Our latest works
    </h3>
    <div className="latest-works-grid" style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        {/* Placeholder */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '0 0 300px', padding: '1rem', background: '#f9f9f9', borderRadius: '12px' }}>
            <div style={{ width: '100%', aspectRatio: '16/10', background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)', borderRadius: '8px', marginBottom: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="2" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
            </div>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '1.1rem', fontWeight: 600, marginBottom: '1rem', textAlign: 'center' }}>There is might be your site!</div>
            <button onClick={onSendEmail} className="group-order__contact-btn group-order__contact-btn_telegram latest-works-card-btn" style={{ border: 'none' }}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2V18" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M18 10H2" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Order a site
            </button>
        </div>
        {/* Times event */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '0 0 300px', padding: '1rem', background: '#f9f9f9', borderRadius: '12px' }}>
            <img src="/msprojector.png" alt="Times event" style={{ width: '100%', aspectRatio: '16/10', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem' }} />
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '1.1rem', fontWeight: 600, marginBottom: '1rem', textAlign: 'center' }}>Media Service Projector</div>
            <button onClick={() => navigate('/program')} className="group-order__contact-btn group-order__contact-btn_telegram latest-works-card-btn" style={{ border: 'none' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="2"/><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" stroke="currentColor" strokeWidth="2"/></svg>
                Watch more
            </button>
        </div>
        {/* Making Sense */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '0 0 300px', padding: '1rem', background: '#f9f9f9', borderRadius: '12px' }}>
            <img src="/pc1.png" alt="Making Sense" style={{ width: '100%', aspectRatio: '16/10', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem' }} />
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '1.1rem', fontWeight: 600, marginBottom: '1rem', textAlign: 'center' }}>Making Sense</div>
            <button onClick={() => navigate('/code-redactor')} className="group-order__contact-btn group-order__contact-btn_telegram latest-works-card-btn" style={{ border: 'none' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="2"/><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" stroke="currentColor" strokeWidth="2"/></svg>
                Watch more
            </button>
        </div>
        {/* Admin Panel */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: '0 0 300px', padding: '1rem', background: '#f9f9f9', borderRadius: '12px' }}>
            <img src="/admin-pc.png" alt="Admin Panel" style={{ width: '100%', aspectRatio: '16/10', objectFit: 'cover', borderRadius: '8px', marginBottom: '1rem' }} />
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '1.1rem', fontWeight: 600, marginBottom: '1rem', textAlign: 'center' }}>Admin Panel</div>
            <button onClick={() => navigate('/admin-panel')} className="group-order__contact-btn group-order__contact-btn_telegram latest-works-card-btn" style={{ border: 'none' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="2"/><path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" stroke="currentColor" strokeWidth="2"/></svg>
                Watch more
            </button>
        </div>
    </div>
    <button
        type="button"
        onClick={() => navigate("/projects")}
        className="group-order__contact-btn group-order__contact-btn_telegram latest-works-all"
        style={{ border: "none" }}
    >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="2"/>
            <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" stroke="currentColor" strokeWidth="2"/>
        </svg>
        View all projects
    </button>
</div>
    );
});

export default PcLatestWorks;
// components/PcScrollShowcase/PcLatestWorks.js
